<template>
  <div>
    <!--<div class="home-wrapper" id="user" >-->
    <div class="h-content" style="    float: none;margin: auto;">
      <div class="home-wrapper-stop" id="home-stop">
        <user-header></user-header>
        <router-view></router-view>
      </div>
    </div>
    <!--<el-col v-else :span="20"  :offset="2">
					<div class="home-wrapper-stop" id="channel-stop" >
						<user-header></user-header>
						<router-view></router-view>
					</div>

    </el-col>-->
<!--    <div class="h-sidebar">
      <user-sidebar></user-sidebar>
    </div> -->
    <!--</div>-->
  </div>
</template>

<script>
import UserHeader from "../components/UserHeader.vue";
import UserSidebar from "../components/sidebars/UsersSidebar.vue";
import Helpers from "../mixins/Helpers";

export default {
  mixins: [Helpers],
  components: {
    UserHeader,
    UserSidebar
  },

  beforeRouteEnter(to, from, next) {
    Store.page.user.submissions.clear();
    Store.page.user.comments.clear();
    Store.page.user.likedSubmissions.clear();

    next();
  },
  created() {
    Store.page.user.submissions.clear();
    Store.page.user.comments.clear();
    Store.page.user.likedSubmissions.clear();
  }
};
</script>
<style scoped>
.user-main-wraper {
  padding-top: 45px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPage.vue